'use strict';

const _ = require('underscore');
const Backbone = require('backbone');

const repositories = {};

class Repository {
    constructor(project) {
        this._project = project;
        this._allocations = new Backbone.Collection();
        this._modelAllocations = {};
        this._specificAllocations = {};
    }

    add(allocation) {
        if(!_.isArray(allocation)) {
            allocation = [allocation]
        }
        allocation = this._allocations.add(allocation, {merge: true});
        _.each(allocation, a => {
            this.getByModel(a.getModel()).add(a, {merge: true});
            this.getBySpecific(a.getSpecific()).add(a, {merge: true});
        });
        return allocation;
    }

    getByModel(model) {
        let allocations = this._modelAllocations[model.id];

        if(!allocations) {
            allocations = new Backbone.Collection(
                this._allocations.filter(a => a.getModel().id == model.id)
            );
            this._modelAllocations[model.id] = allocations;
        }

        return allocations;
    }

    getBySpecific(specific) {
        let allocations = this._specificAllocations[specific.id];

        if(!allocations) {
            allocations = new Backbone.Collection(
                this._allocations.filter(a => a.getModel().id == specific.id)
            );
            this._specificAllocations[specific.id] = allocations;
        }

        return allocations;
    }

    static find(project) {
        let r = repositories[project.id];
        if (!r) {
            r = new Repository(project);
            repositories[project.id] = r;
        }
        return r;
    }
}

module.exports = Repository;



// WEBPACK FOOTER //
// ./balus/domain/repository/allocation/index.js